import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../store/AuthContext";
import { getHomeRouteByRole, resolveStaffHomeRoute } from "../utils/roleRoutes";
import { hasAdminModuleAccess } from "../utils/adminPermissions";

function resolveFallbackRoute(user) {
  const staffHome = resolveStaffHomeRoute(user);
  if (staffHome) return staffHome;
  return getHomeRouteByRole(user?.role, user);
}

export default function ProtectedRoute({
  children,
  allowedRoles = [],
  requiredAdminModule = "",
  requiredAnyAdminModules = [],
}) {
  const { accessToken, user } = useAuth();
  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }
  if (allowedRoles.length > 0) {
    if (!user?.role) {
      return <Navigate to="/login" replace />;
    }
    const role = String(user.role).toUpperCase();
    const allowed = allowedRoles.map((r) => String(r).toUpperCase());
    if (!allowed.includes(role)) {
      return <Navigate to={resolveFallbackRoute(user)} replace />;
    }
  }
  if (requiredAdminModule && !hasAdminModuleAccess(user, requiredAdminModule)) {
    return <Navigate to={resolveFallbackRoute(user)} replace />;
  }
  if (requiredAnyAdminModules.length > 0) {
    const allowed = requiredAnyAdminModules.some((module) => hasAdminModuleAccess(user, module));
    if (!allowed) {
      return <Navigate to={resolveFallbackRoute(user)} replace />;
    }
  }
  return children;
}
